'use client';

import {TextArea as GFiberTextArea} from '@pixel-party/TextArea/v2';
import type {ComponentProps, ReactNode} from 'react';
import {forwardRef} from 'react';

type BaseProps = ComponentProps<typeof GFiberTextArea>;

interface Props extends Omit<BaseProps, 'errorText'> {
  label: string;
  errorText?: ReactNode;
}

export const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({label, errorText, required, ...props}, ref) => {
    return (
      <GFiberTextArea
        {...props}
        ref={ref}
        id={props.id || props.name}
        invalid={!!errorText}
        errorText={errorText}
        required={required}
        label={label ? `${label}${required ? ' *' : ''}` : undefined}
      />
    );
  },
);

TextArea.displayName = 'TextArea';
